
export default class CommuneService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    autocomplete(nom, options = {}) {
        const { tribunal , codePostal, horsCompetence} = options;
        return this.axios
            .get("/api/commune/autocomplete", { params: {nom, tribunal , codePostal, horsCompetence } })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    autocompleteEnum(nom, options = {}) {
        const { codePostal } = options;
        return this.axios
            .get("/api/commune/autocomplete-enum", { params: {nom, codePostal } })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }
}
